import de from "./de.js";
import en from "./en.js";

export const LEONARDO_LOCALES = ["de", "en"];
export const DEFAULT_LEONARDO_LOCALE = "de";

const catalogs = { de, en };

export const HOTEL_OPTION_IDS = ["hotel-wakeup-5", "hotel-quick-15"];

const HOTEL_OPTION_META = {
  "hotel-wakeup-5": {
    serviceKey: "dr-hoffmann-wakeup-onsite",
    price: "5 €",
    durationMinutes: 5,
    serviceDurationMinutes: 5,
    priceCents: 500,
    offerType: "wakeup_onsite",
    personCount: 1,
    minimumLeadMinutes: 30,
    featured: true,
  },
  "hotel-quick-15": {
    serviceKey: "dr-hoffmann-hotel-15",
    price: "39 €",
    durationMinutes: 15,
    priceCents: 3900,
    minimumLeadMinutes: 30,
    featured: false,
  },
  "hotel-performance-60": {
    serviceKey: "dr-hoffmann-hotel-60",
    price: "125 €",
    durationMinutes: 60,
    priceCents: 12500,
    featured: false,
  },
};

export const createTranslator = (locale) => {
  const messages = catalogs[locale] || catalogs[DEFAULT_LEONARDO_LOCALE];
  return (key, vars) => {
    let str = messages[key] ?? catalogs.de[key] ?? key;
    if (vars) {
      Object.entries(vars).forEach(([k, v]) => {
        str = str.replace(new RegExp(`\\{${k}\\}`, "g"), String(v ?? ""));
      });
    }
    return str;
  };
};

export const getDateLocale = (locale) => (locale === "en" ? "en-GB" : "de-DE");

export const getHotelOptions = (t) =>
  HOTEL_OPTION_IDS.map((id) => {
    const meta = HOTEL_OPTION_META[id];
    return {
      id,
      serviceKey: meta.serviceKey,
      offerType: meta.offerType,
      personCount: meta.personCount,
      serviceDurationMinutes: meta.serviceDurationMinutes,
      minimumLeadMinutes: meta.minimumLeadMinutes,
      title: t(`options.${id}.title`),
      subtitle: t(`options.${id}.subtitle`),
      price: meta.price,
      priceNote: t(`options.${id}.priceNote`),
      description: t(`options.${id}.description`),
      featured: meta.featured,
      durationMinutes: meta.durationMinutes,
      priceCents: meta.priceCents,
    };
  });

const GALLERY_KEYS = ["left", "middle", "a", "b", "c"];

export const getGallery = (t) =>
  GALLERY_KEYS.map((srcKey) => ({
    srcKey,
    alt: t(`gallery.${srcKey}.alt`),
  }));
